import React, { Component } from "react";
import Switch from "react-switch";
import { Redirect } from "react-router-dom";
import Modal from 'react-awesome-modal';
import Vimeo from '@u-wave/react-vimeo';

import withServices from "src/HOCs/withServices";
import {
  PackageItem,
  PackagesWrapper, Row,
  ModalContainer
} from "../../Onboard/Common/Common.styles";
import {
  Container,
  StyledRow
} from "../../Onboard/PrePayment/PrePayment.styles";
import Navbar from "../../../components/CustomNav/CustomNav.Component";
import { toast, ToastContainer } from "react-toastify";
import { ModalContent, FeatureColumn, SectionHeader} from './UpdateSubscription.styles';

import banner from '../../../assets/images/subscription/update-sub-banner.jpg';
import assess from '../../../assets/images/subscription/assess.jpg';
import analyse from '../../../assets/images/subscription/analyse.jpg';
import insight from '../../../assets/images/subscription/insight.jpg';
import learn from '../../../assets/images/subscription/learn.jpg';
import select from '../../../assets/images/subscription/select.jpg';
interface IProps {
  services: any;
  history: any;
  isParent: boolean;
  isStudent: boolean;
}
interface IState {
  subscriptionInfo: any;
  subscriptionLoaded: boolean;
  toLogin: boolean;
  packages: any;
  planID: string;
  currentPlanType: string;
  selectedPackage: any;
  initialPlanType: string
  checkoutModalOpen: boolean;
  planName: string
  planPrice: any,
  subscribedPackageID: any
}

class UpdateSubscription extends Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      toLogin: false,
      subscriptionInfo: null,
      subscriptionLoaded: false,
      packages: [],
      planID: "",
      currentPlanType: "MONTHLY",
      selectedPackage: null,
      initialPlanType: "",
      planName: "",
      planPrice: null,
      checkoutModalOpen: false,
      subscribedPackageID: null
    };

    this.switchPackage = this.switchPackage.bind(this);
    this.handleCancelSubscription = this.handleCancelSubscription.bind(this);
  }

  public async componentDidMount() {
    const {
      services: { adminAPI, isUserLoggedIn },
    } = this.props;
    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }
    const [packagesRes, userInfoRes] = await Promise.all([
      adminAPI.getPackagesList(),
      adminAPI.fetchUserInfo(),
    ]);
    if (packagesRes.ok) {
      const packages = packagesRes.data.packages;
      const userInfo = userInfoRes.data;
      const subscriptionInfo = userInfo.subscription;
      const currentPackage = userInfo.package;
      this.setState({
        packages,
        subscriptionInfo,
        subscriptionLoaded: true,
        planID: currentPackage.Plans[0].id,
        currentPlanType: currentPackage.Plans[0].type,
        initialPlanType: currentPackage.Plans[0].type,
        subscribedPackageID: currentPackage.id
      });
    }
  }

  public onProfile = () => {
    this.props.history.goBack();
  };

  public onLogout = () => {
    this.setState({ toLogin: true });
  };

  // public getCurrentPlanID = (userSubscription, currentPackage) => {
  //   const planType = userSubscription.Type;
  //   const packagePlans = currentPackage.Plans;
  //   const currentPlan = packagePlans.find((plan) => {
  //     const str = planType.split("_");
  //     if (str[1] === plan.type) {
  //       return plan;
  //     }
  //   });
  //   return [currentPlan.id, currentPlan.type];
  // };
public toggleModal = () => {
  const  { checkoutModalOpen } = this.state;
  this.setState({checkoutModalOpen: !checkoutModalOpen});
}
  public togglePlanType = () => {
    const { currentPlanType } = this.state;
    if (currentPlanType === "MONTHLY") {
      this.setState({ currentPlanType: "YEARLY" });
    }
    if (currentPlanType === "YEARLY") {
      this.setState({ currentPlanType: "MONTHLY" });
    }
  };

  public checkout(selectedPackageID, packageName, planID, planType, planPrice) {
    this.setState({ selectedPackage: selectedPackageID, planID, planName: packageName, currentPlanType: planType, planPrice, checkoutModalOpen: true });
  }

  public async switchPackage() {
    const { selectedPackage, planID, currentPlanType } = this.state;
    const {
      services: { parentsAPI, studentsAPI },
      isParent,
      isStudent,
    } = this.props;
    const item = {
      pk: selectedPackage,
      plan_id: planID,
      plan_type: currentPlanType,
    };

    alert(JSON.stringify(item, null, 2));

    let res: any = {};
    if (isParent) {
      res = await parentsAPI.switchSubscriptionPackage(item);
    }
    if (isStudent) {
      res = await studentsAPI.switchSubscriptionPackage(item);
    }
    if (res.ok) {
      toast.success("You have successfully changed your subscription");
    } else {
      toast.error("Sorry, you cannot change your subscription at the moment");
    }
  }

  public async handleCancelSubscription() {
    const {
      services: { parentsAPI },
    } = this.props;
    const cancelRes = await parentsAPI.cancelSubscription();
  }
  public renderPageContent = () => {
    return (
      <React.Fragment>
        <Row width="100%">
          <FeatureColumn width="50%">
            <img className="feature-banner" src={banner} alt="" />
          </FeatureColumn>
          <FeatureColumn width="50%" padding="2em">
            <h1 className="page-heading">
              UPGRADE YOUR PERFORMANCE <br /> ACCOUNT TODAY
            </h1>
            <p className="feature-detail" style={{ maxWidth: "400px" }}>
              Tens of thousands of pupils over five years have trusted us to
              teach them how to learn, the skills based approach to their
              learning. <br />
              <br /> Cut down revision time and the need for endless tutoring by
              equipping them with the right skills to thrive in class, at home
              and in the exam-hall.
            </p>
            <button className="green-button upgrade-now">Upgrade Now</button>
          </FeatureColumn>
        </Row>
        <SectionHeader>
          <h2 className="section-heading">
            Why upgrade to Performance Learning?
          </h2>
          <h2 className="section-subheading">
            ASSESS.&nbsp;ANALYZE.&nbsp;SELECT.&nbsp;LEARN.&nbsp;INSIGHT
          </h2>
        </SectionHeader>
        {/* Assess */}
        <Row width="100%" background="#1a1a1a">
          <FeatureColumn width="50%" padding="2em" align="center">
            <h1 className="feature-head">ASSESS</h1>
            <p className="feature-detail">
              Performance Learning starts with a deep dive into your child’s
              skill level,
              <br />
              perceptions and learning style
            </p>
          </FeatureColumn>
          <FeatureColumn width="50%">
            <img className="feature-banner" src={assess} alt="" />
          </FeatureColumn>
        </Row>

        {/* analyse */}
        <Row width="100%">
          <FeatureColumn width="50%">
            <img className="feature-banner" src={analyse} alt="" />
          </FeatureColumn>
          <FeatureColumn width="50%" padding="2em">
            <h1 className="feature-head">ANALYSE</h1>
            <p className="feature-detail">
              The results are presented to you with us <br /> on standby to help
            </p>
          </FeatureColumn>
        </Row>

        {/* select */}
        <Row width="100%" background="#1a1a1a">
          <FeatureColumn width="50%" padding="2em" align="center">
            <h1 className="feature-head">SELECT</h1>
            <p className="feature-detail">
              Select which subject or course your child would <br /> like to
              improve in from <span>Performance Learning’s </span>course
              directory
            </p>
          </FeatureColumn>
          <FeatureColumn width="50%">
            <img className="feature-banner" src={select} alt="" />
          </FeatureColumn>
        </Row>

        {/* learn */}
        <Row width="100%">
          <FeatureColumn width="50%">
            <img className="feature-banner" src={learn} alt="" />
          </FeatureColumn>
          <FeatureColumn width="50%" padding="2em">
            <h1 className="feature-head">LEARN</h1>
            <p className="feature-detail">
              Using AI Performance Learning will personalise your child’s
              learning
              <br /> journey basis their assessment results,
              <br /> coaching them on how to learn
            </p>
          </FeatureColumn>
        </Row>

        {/* insight */}
        <Row width="100%" background="#1a1a1a">
          <FeatureColumn width="50%" padding="2em" align="center">
            <h1 className="feature-head">INSIGHT</h1>
            <p className="feature-detail">
              Intuitive, subtle, intelligent assessment enables your child to
              <br />
              master their learning (all reported back to you)
            </p>
          </FeatureColumn>
          <FeatureColumn width="50%">
            <img className="feature-banner" src={insight} alt="" />
          </FeatureColumn>
        </Row>
        <SectionHeader>
          <h2 className="section-heading">PERFORMANCE LEARNING SUCCESS</h2>
        </SectionHeader>
        <Row width="100%" height="400px" background="#1a1a1a">
          <FeatureColumn width="50%" align="center">
            <Vimeo
              className="prepayment-video"
              video="https://player.vimeo.com/video/49384334"
              height={480}
              responsive={true}
            />
          </FeatureColumn>
          <FeatureColumn width="50%">
            <p className="upgrade-testimonial">
              Lorem ipsum dolor sit amet <br /> consectetur adipisicing elit.{" "}
              <br />
              Eaque, voluptatibus.
            </p>
            <p className="testimonial-own">MR. J SMITH - TEACHER, BIRMINGHAM</p>
          </FeatureColumn>
        </Row>
      </React.Fragment>
    );
  }
  public renderPackages = () => {
    const { packages, subscriptionLoaded, currentPlanType, subscriptionInfo, subscribedPackageID } = this.state;
    const availablePackages = packages.filter(item => item.id !== subscribedPackageID);
    const plexSingleFeatures = (
      <React.Fragment>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Unlimited Access to all Performance Learning training for one learner
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Blended learning pathways, bespoke to your childs social, emotional,
          mental health
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Lessons focused on improving their sleep, retention skills,
          time-management, learning anxieties while simulteniously boosting core
          subjects
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Contiously challenged through 5 levels of Performance Learning (Easy
          to Genius) to progress ahead of their existing age range{" "}
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Contious assessment and reporting delivered as often as daily to help
          you coach your child to academic success
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Early idenfication of mental health and subject specific blocks to
          academic success
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Skills analyses for future course selections
        </p>
      </React.Fragment>
    );

    const plexFamilyFeatures = (
      <React.Fragment>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Blended learning pathways, bespoke to your childs social, emotional,
          mental health
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Lessons focused on improving their sleep, retention skills,
          time-management, learning anxieties while simulteniously boosting core
          subjects
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Contiously challenged through 5 levels of Performance Learning (Easy
          to Genius) to progress ahead of their existing age range{" "}
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Contious assessment and reporting delivered as often as daily to help
          you coach your child to academic success
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Early idenfication of mental health and subject specific blocks to
          academic success
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Half the price of a Single only license{" "}
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Per child strengths and weaknesses comparison{" "}
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Skills analyses for future course selections
        </p>
      </React.Fragment>
    );
    const assessmentOnlyFeatures = (
      <React.Fragment>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Test and Exam Results Prediction
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Early identification of mental-health problems
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Skills analyses for future course selections
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Focus resources accordingly at home to deliver optimal home-learning
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />5 alert-level identification process on
          whether their school-learning is on-track
        </p>
        <p className="package-benefit">
          <i className="fa fa-check" />
          Per child strengths and weaknesses comparison* when more than one
          assessment is purchased
        </p>
      </React.Fragment>
    );
    if (subscriptionLoaded) {
      return (
        <React.Fragment>
          <StyledRow
            marginTop="2em"
            height="auto"
            show={true}
            // ref={this.packagesRef}
          >
            <h1 className="package-heading" style={{ fontSize: "24px" }}>
              {" "}
              YOU ARE CURRENTLY ON{" "}
              <span>
                {subscriptionLoaded ? subscriptionInfo.PackageName : ""}
              </span>
              <br />
              YOU CAN MOVE TO ONE OF THESE PACKAGES
            </h1>
          </StyledRow>

          <StyledRow show={true} backgroundColor="transparent">
            <PackagesWrapper>
              {availablePackages.map((item) => {
                const currentPlan = item.Plans[0];
                return (
                  <PackageItem key={`package${item.id}`}>
                    <div className="package-name">
                      <h1 className="package-title">{item.Name}</h1>
                      <p className="package-target">{item.Description}</p>
                    </div>
                    <div className="package-value">
                      <h1 className="price">
                        &pound;
                        {currentPlan.price}
                        <span> {currentPlan.type}</span>
                      </h1>
                      {item.id === 2
                        ? plexFamilyFeatures
                        : item.id === 3
                        ? plexSingleFeatures
                        : assessmentOnlyFeatures}
                    </div>
                    <div className="features-list">
                      <button
                        className={`package-button green-button`}
                        onClick={this.checkout.bind(
                          this,
                          item.id,
                          item.Name,
                          currentPlan.id,
                          currentPlan.type,
                          currentPlan.price
                        )}
                      >
                        {this.state.selectedPackage === item.id ? (
                          <p className="p-selected-package">
                            <i
                              className="fa fa-check"
                              style={{ fontSize: "18px", color: "#000" }}
                            />
                            Selected
                          </p>
                        ) : (
                          <p className="p-selected-package">Switch</p>
                        )}
                      </button>
                    </div>
                  </PackageItem>
                );
              })}
            </PackagesWrapper>
          </StyledRow>
        </React.Fragment>
      );
    } else {
      console.log("Packages Loading...");
      return;
    }
  };

  public renderSwitchPackageModal = () => {
    const  { planID, planName, selectedPackage, planPrice, currentPlanType, checkoutModalOpen } = this.state;
    return (
      <Modal
        visible={checkoutModalOpen}
        effect="fadeInUp"
        onClickAway={this.toggleModal}
        width="580"
        height="300"
      >
        <ModalContainer height="300px">
          <ModalContent>
            <h1 className="new-package">
              You are about to move to the <br/> <span>{planName} package</span> 
            </h1>
            <h2 className="pricing">
              This package costs<br/> <span>&pound;{planPrice} billed {currentPlanType}</span>
            </h2>
            <button className="switch-package blue-button" onClick={this.switchPackage}>Switch Package</button>
          </ModalContent>
        </ModalContainer>
      </Modal>
    );
  }
  public render() {
    const { subscriptionInfo, subscriptionLoaded } = this.state;
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    return (
      <div>
        <ToastContainer />
        <Navbar logoutParent={this.onLogout} profileParent={this.onProfile} />
        {this.renderSwitchPackageModal()}
        <Container>
          {this.renderPageContent()}
          <StyledRow showBg = {false} height="auto" show={true}>
            {this.renderPackages()}
          </StyledRow>
        </Container>
      </div>
    );
  }
}

export default withServices(UpdateSubscription);



// WEBPACK FOOTER //
// ./src/pages/Profile/UpdateSubscription/UpdateSubscription.Component.tsx